import { render, staticRenderFns } from "./CanceledSales.vue?vue&type=template&id=b5b549b0&"
import script from "./CanceledSales.vue?vue&type=script&lang=js&"
export * from "./CanceledSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports